import { startErrorReporter } from "../../../common/errorReporter";
import { bootstrapJupyterLabSessionlessEditor } from "./bootstrapJupyterLabSessionlessEditor";

startErrorReporter();
bootstrapJupyterLabSessionlessEditor();
